import React from "react"
import OpenIDLandingLegacy from "@views/features/openid-landing"
import SEO from "@components/SEO"

const IndexPage = () => (
  <div>
    <SEO
      title="EngineID - OpenID Connect"
      keywords={[
        `engineid`,
        `security`,
        `openid connect`,
        `openid`,
        `oidc`,
        `federated login`,
        `authentication`,
        `authorization`,
        `api`,
        `cloud`,
        `development`,
        `sdk`,
        `identity management`,
        `access management`,
      ]}
    />
    <OpenIDLandingLegacy />
  </div>
)

export default IndexPage
